export class ExportReceiptModel {
    public ID?: number;
    public UID?: number;
    public Username?: string;
    public Status?: number;
    public StatusDetail!: any;
    public ExchangeRate!: number;
    public Weight!: number;
    public Volume!: number;
    public NumberOfPack!: number;
    public FeeShip!: number;
    public FeeShipVND!: number;
    public FeeType!: number;
    public Price!: number;
    public Amount!: number;
    public PaymentMethod!: number;
    public PaymentDate!: string;
    public ExportDate!: string;
    public CreatedDate!: string;
}
export class SummaryExportReceiptModel {
    public TotalStatusAll!: number;
    public TotalStatus1!: number;
    public TotalStatus2!: number;
    public TotalStatus3!: number;
  }
